const faqIds = {
  IS_IT_FREE: 'IS_IT_FREE',
  HOW_IS_THE_APPOINTMENT: 'HOW_IS_THE_APPOINTMENT',
  CAN_I_CHOOSE_THE_DEALER: 'CAN_I_CHOOSE_THE_DEALER',
  WHEN_I_GET_PAID: 'WHEN_I_GET_PAID',
  WHAT_IF_I_DECIDE_TO_NOT_SELL: 'WHAT_IF_I_DECIDE_TO_NOT_SELL'
}

export const faqQuestions = {
  [faqIds.IS_IT_FREE]: {
    question: `INSTANT_OFFER.LANDING.FAQS.${faqIds.IS_IT_FREE}_QUESTION`,
    answer: `INSTANT_OFFER.LANDING.FAQS.${faqIds.IS_IT_FREE}_RESPONSE`,
    tracking: 'servicio gratuito'
  },
  [faqIds.HOW_IS_THE_APPOINTMENT]: {
    question: `INSTANT_OFFER.LANDING.FAQS.${faqIds.HOW_IS_THE_APPOINTMENT}_QUESTION`,
    answer: `INSTANT_OFFER.LANDING.FAQS.${faqIds.HOW_IS_THE_APPOINTMENT}_RESPONSE`,
    tracking: 'como sera la cita'
  },
  [faqIds.CAN_I_CHOOSE_THE_DEALER]: {
    question: `INSTANT_OFFER.LANDING.FAQS.${faqIds.CAN_I_CHOOSE_THE_DEALER}_QUESTION`,
    answer: `INSTANT_OFFER.LANDING.FAQS.${faqIds.CAN_I_CHOOSE_THE_DEALER}_RESPONSE`,
    tracking: 'elegir concesionario'
  },
  [faqIds.WHEN_I_GET_PAID]: {
    question: `INSTANT_OFFER.LANDING.FAQS.${faqIds.WHEN_I_GET_PAID}_QUESTION`,
    answer: `INSTANT_OFFER.LANDING.FAQS.${faqIds.WHEN_I_GET_PAID}_RESPONSE`,
    tracking: 'cuando recibire pago'
  },
  [faqIds.WHAT_IF_I_DECIDE_TO_NOT_SELL]: {
    question: `INSTANT_OFFER.LANDING.FAQS.${faqIds.WHAT_IF_I_DECIDE_TO_NOT_SELL}_QUESTION`,
    answer: `INSTANT_OFFER.LANDING.FAQS.${faqIds.WHAT_IF_I_DECIDE_TO_NOT_SELL}_RESPONSE`,
    tracking: 'si decido no vender'
  }
}

export const faqTracking = [
  faqQuestions[faqIds.IS_IT_FREE].tracking,
  faqQuestions[faqIds.HOW_IS_THE_APPOINTMENT].tracking,
  faqQuestions[faqIds.CAN_I_CHOOSE_THE_DEALER].tracking,
  faqQuestions[faqIds.WHEN_I_GET_PAID].tracking,
  faqQuestions[faqIds.WHAT_IF_I_DECIDE_TO_NOT_SELL].tracking
]
